module.exports = __webpack_public_path__ + "static/media/obr_poz_2.895143d0.jpg";